import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../../initial-page/layout/Header";
import Sidebar from "../../initial-page/layout/Sidebar";
import ThemeSettings from "../../initial-page/themeSettings";
// import AtualizacoesPopup from "../../feature-module/pages/atualizacoes/AtualizacoesPopup";

export const HeaderLayout = () => {
  const data = useSelector((state) => state.toggle_header);
  return (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      <Header />
      <Sidebar />
      <Outlet />
      {/* <AtualizacoesPopup /> */}
      <ThemeSettings />
    </div>
  );
};

export const AuthLayout = () => {
  const data = useSelector((state) => state.toggle_header);
  return (
    <div className={data ? "header-collapse" : ""}>
      <Outlet />
      <ThemeSettings />
    </div>
  );
};

export const PosLayout = () => (
  <div>
    <Header />
    <Outlet />
    <ThemeSettings />
  </div>
);
